import { ObjectToHtml } from './formaterBanner';
import { PrintElement, PrintDiv } from './printElement';
import { SaveReanimateFile } from './fileManager'
import { BannerToStages } from './bannerToStages.js'
import JSZip from 'jszip';
import FileSaver from 'file-saver';

export async function DownloadPackHTML(master, assets, listaReplicas, imageFormat, printStages) {
  var aba = document.getElementById("aba_replica_" + listaReplicas[0].width + "x" + listaReplicas[0].height);
  aba.click();
  await sleep();
  await DownloadPack(master, assets, listaReplicas, imageFormat, printStages)
  return true;
}

function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function sleep() {
  await timeout(2000);
  return true;
}

export async function DownloadPackImages(master, assets, listaReplicas, imageFormat) {
  const zip = new JSZip();  

  let imageMaster = await PrintElement(master, true, false);
  const blobimageMaster = dataURItoBlob(imageMaster);
  const filenameMaster = `${master.width}x${master.height}`;
  let imgMasterBlob = blobimageMaster;

  if (imageFormat === 'jpg') {
    imgMasterBlob = convertToJPG(blobimageMaster, filenameMaster);    
  } else if (imageFormat === 'webp') imageMaster = await convertBase64PngToWebp(imageMaster);

  master.estatico = true;

  // !!! Codes commented below is causing preview disappearing !!!
  //
  // listaReplicas.forEach(replica => {
  //   replica.estatico = true;
  // });

  const savedFile = SaveReanimateFile(master, assets, listaReplicas, false);
  zip.file(`${filenameMaster}.rean`, savedFile);
  zip.file(`${filenameMaster}.${imageFormat.toString()}`, imgMasterBlob);
  for (var j = 0; j < listaReplicas.length; j++) {
    const replica = listaReplicas[j];
    if (replica.pack) {
      let bckp = await PrintElement(replica, false, false);
      if (imageFormat === 'webp') bckp = await convertBase64PngToWebp(bckp);
      const filename = replica.width + "x" + replica.height;
      const blobBackup = dataURItoBlob(bckp);
      let replicaBlob = blobBackup;

      if (imageFormat === 'jpg') {
        replicaBlob = await convertToJPG(blobBackup, filename);
      }
      zip.file(`${filename}.${imageFormat.toString()}`, replicaBlob);
    }
  }
  zip.generateAsync({type: "blob"}).then(function(content) {
    FileSaver.saveAs(content, "pack.zip");
  });
}

async function convertBase64PngToWebp(base64Png) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Png;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('Canvas context inválido');

      ctx.drawImage(img, 0, 0);
      const base64Webp = canvas.toDataURL('image/webp', 0.8); // qualidade de 0 a 1
      console.log(base64Webp)
      resolve(base64Webp);
    };

    img.onerror = (e) => {
      reject(e);
    }
  });
}

/**
 * @see https://developer.mozilla.org/pt-BR/docs/Web/API/Blob
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
 * @param {Blob} fileBlob
 * @param {String} fileName
 * @returns {Promise<Blob>}
 */
function convertToJPG(fileBlob, fileName) {
  const promise = new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.readAsDataURL(fileBlob);
    fr.onload = (event) => {
      const image = new Image();
      image.src = event.target.result;
      
      image.onload = () => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d');

        canvas.width = image.width;
        canvas.height = image.height;
        canvas.style.display = 'none';

        context.fillStyle = "#000";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0);

        canvas.toBlob((blob) => {
          try {
            const jpgFile = new File([blob], `${fileName}.jpg`, {
              type: 'image/jpeg',
              lastModified: Date.now()
            })
            
            resolve(jpgFile);
          } catch (err) {
            console.error(`Error to convert PNG to JPG: ${err}`);
            reject(err);
          }
        }, 'image/jpeg');
      };
    }
  });

  return promise;
}

async function DownloadPack(master, assets, listaReplicas, imageFormat, printStages) {
  var zip = new JSZip();
  const filenameMaster = `${master.width}x${master.height}`;
  let imageMaster = await PrintElement(master, true);
  if (imageFormat === 'webp') imageMaster = await convertBase64PngToWebp(imageMaster);
  const blobimageMaster = dataURItoBlob(imageMaster);
  zip.file(`${filenameMaster}.${imageFormat.toString()}`, blobimageMaster);
  zip.folder(`${filenameMaster}_DCM`).file(`${filenameMaster}.html`, ObjectToHtml(master));
  for (var j = 0; j < listaReplicas.length; j++) {
    const replica = listaReplicas[j];
    if (replica.pack) {
      const filename = `${replica.width}x${replica.height}`;
      let imageReplica = await PrintElement(replica, false);
      if (imageFormat === 'webp') imageReplica = await convertBase64PngToWebp(imageReplica);
      var blobBackup = dataURItoBlob(imageReplica);
      zip.file(filename + `.${imageFormat.toString()}`, blobBackup);
      if (printStages) {
        var listB64 = await DownloadPackImageStages(replica);
        listB64.forEach((b64, item) => {
          var blobStage = dataURItoBlob(b64);          
          zip.folder('preview').folder(`${filename}`).file(`${filename}-step-${item + 1}.${imageFormat}`, blobStage);
        });
      }
      const html = ObjectToHtml(replica);
      zip.folder(`${filename}_DCM`).file(`${filename}.html`, html);
    }
  }

  var savedFile = SaveReanimateFile(master, assets, listaReplicas, false);
  zip.file(`${filenameMaster}.rean`, savedFile);
  zip.generateAsync({type: "blob"}).then(function(content) {
    FileSaver.saveAs(content, "pack.zip");
  });
}

export async function DownloadPackImage(master, assets, listaReplicas, imageFormat) {
  var aba = document.getElementById("aba_replica_" + listaReplicas[0].width + "x" + listaReplicas[0].height);
  aba.click();
  await sleep();
  await DownloadPackImages(master, assets, listaReplicas, imageFormat)
}

export async function DownloadPackImageStages(replica) {
  var aba = document.getElementById("aba_replica_" + replica.width + "x" + replica.height);
  aba.click();
  await sleep();
  const stages = BannerToStages(replica);
  const listB64 = [];
  for(var i = 0; i < stages.length; i++) {
    const id = `id-stage-${replica.width}-${replica.height}-step-${i + 1}`;
    var b64 = await PrintDiv(id);
    listB64.push(b64);
  }
  return listB64;
}

function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(',')[1]);
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  var blob = new Blob([ab], {type: mimeString});
  return blob;

}